import { RESET_UNREAD_COUNT, SET_UNREAD_COUNT } from './actionTypes';

export function setUnreadCount(count: number) {
  return {
    type: SET_UNREAD_COUNT,
    payload: count,
  };
}

export function resetUnreadCount() {
  return {
    type: RESET_UNREAD_COUNT,
  };
}

const NotificationsAction = {
  setUnreadCount,
  resetUnreadCount,
};

export default NotificationsAction;
